import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Home from "../templates/Home";
import Task from "../templates/Task";
import Login from "../templates/Login";
import ProfileSettings from "../templates/Settings";
import Profile from "../templates/Profile";
import ResetPassword from "../templates/ForgotPassword";
import Topic from "../templates/Topic";
import Lesson from "../templates/Lesson";
import DigitalMeetings from "../templates/DigitalMeetings";
import Organization from "../templates/Organization";
import MyBoards from "../templates/MyBoards";
import Inspiration from "../templates/Inspiration";
import BookCoach from "../templates/BookCoach";
import SustainAdmin from "../templates/SustainAdmin";
import HallbarIndex from "../templates/HallbarIndex";
import OfflineHallbarIndex from "../templates/OfflineHallbarIndex";
import OfflineHVIResults from "../templates/OfflineHVIResults";
import Articles from "../partials/Articles/Articles";
import SingleArticles from "../partials/Articles/SingleArticle";
import SingleWebinar from "../partials/Articles/SingleWebinar";
import ContactUs from "../templates/ContactUs";
import Plans from "../templates/Plans";
import NotFound from "../templates/NotFound";
import BokaVard from "../templates/BokaVard";
import SjukFrisk from "../templates/SjukFrisk";
import GraTillGuld from "../templates/GraTillGuld";
import Community from "../templates/Community";
import MyTasks from "../templates/MyTasks";
import MyBattery from "../templates/MyBattery";
import OrganizationIndex from "../templates/OrganizationIndex";
import CostCalculator from "../templates/CostCalculator";
import PartnerPortal from "../templates/PartnerPortal";
import TeacherGuide from "../templates/TeacherGuide";
import StudentGuide from "../templates/StudentGuide";
import OfflineOvi from "../templates/OfflineOvi";
import OfflineOviResults from "../templates/OfflineOviResults";
import SustainMeIndex from "../templates/SustainMeIndex";
import SustainIndex from "../templates/SustainIndex";
import Anvandarguide from "../templates/Anvandarguide";
import Dialogkunskap from "../templates/Dialogkunskap";
import PieCharts from "../templates/PieCharts";

const PrivateRoutes = () => {
    return (

        <Switch>
            <Route exact path="/" component={Home} />
            <Route
            exact
            path="/board/:board_id/:board_view?"
            component={Task}
            />
            <Route
            exact
            path="/board/:board_id/task/:task_id"
            component={Task}
            />
            <Route exact path="/change-boards/" component={MyBoards} />
            <Route exact path="/my-tasks/" component={MyTasks} />
            <Route exact path="/my-tasks/:task_id" component={MyTasks} />
            <Route exact path="/login/" component={Login} />
            <Route exact path="/profile/" component={Profile} />
            <Route exact path="/settings/:stepStatus?" component={ProfileSettings} />
            <Route exact path="/reset-password/" component={ResetPassword} />
            <Route exact path="/my-battery/" component={MyBattery} />
            <Route
            exact
            path="/board/:board_id/guide/:lesson/:topic/"
            component={Topic}
            />
            <Route
            exact
            path="/board/:board_id/guide/:lesson/"
            component={Lesson}
            />
            <Route
            exact
            path="/digitala-traffar/"
            component={DigitalMeetings}
            />
            <Route
            exact
            path="/digitala-traffar/:webinarid"
            component={SingleWebinar}
            />
            <Route
            exact
            path="/kunskap-inspiration/"
            component={Inspiration}
            />
            <Route
            exact
            path="/kunskap-inspiration/:categoryslug?/:childslug?"
            component={Articles}
            />
            <Route
            exact
            path="/kunskap-inspiration/:categoryslug/p/:post_id"
            component={SingleArticles}
            />
            <Route exact path="/boka-coach-konsult/" component={BookCoach} />
            <Route
            exact
            path="/organizations/:organization_id?/:method?/:team_id?/:sub_teams?/:sub_team_id?"
            component={Organization}
            />
            <Route exact path="/sustain-admin/" component={SustainAdmin} />
            <Route exact path="/hvi/" component={HallbarIndex} />
            <Route exact path="/hwi/" component={HallbarIndex} />
            <Route exact path="/:company/hvi/" component={OfflineHallbarIndex} />
            <Route exact path="/:company/hvi/results" component={OfflineHVIResults} />
            <Route exact path="/:company/ovi/" component={OfflineOvi} />
            <Route exact path="/:company/ovi/results" component={OfflineOviResults} />
            <Route exact path="/ovi/" component={OrganizationIndex} />
            <Route exact path="/owi/" component={OrganizationIndex} />
            <Route exact path="/:company/hwi/" component={OfflineHallbarIndex} />
            <Route exact path="/:company/owi/" component={OfflineOvi} />
            <Route exact path="/:company/hwi/results" component={OfflineHVIResults} />
            <Route exact path="/:company/owi/results" component={OfflineOviResults} />
            <Route exact path="/contact/" component={ContactUs} />
            <Route exact path="/boka-vard/" component={BokaVard} />
            <Route exact path="/sjuk-frisk/" component={SjukFrisk} />
            <Route exact path="/fran-gra-till-guld/:results?" component={GraTillGuld} />
            <Route exact path="/plans/:plan?/:type?/:pstatus?" component={Plans} />
            <Route exact path="/community/" component={Community} />
            <Route exact path="/kostnadskalkylator/" component={CostCalculator} />
            <Route exact path="/partner-portal/:lesson?/:topic?" component={PartnerPortal} />
            <Route exact path="/lararhandledning/:lesson?/:topic?" component={TeacherGuide} />
            <Route exact path="/lararhandledning-f-3/:lesson?/:topic?" component={StudentGuide} />
            <Route exact path="/smi/:school/:classroom?/:result_type?" component={SustainMeIndex} />
            <Route exact path="/si/:results?" component={SustainIndex} />
            <Route exact path="/:group/si/:results?" component={SustainIndex} />
            <Route exact path="/anvandarguide/:lesson?/:topic?" component={Anvandarguide} />
            <Route exact path="/dialogkunskap/:lesson?/:topic?" component={Dialogkunskap} />
            <Route exact path="/piecharts/:chart_id?" component={PieCharts} />
            <Route exact path="/wp-content/themes/sustainchangeprod/" element={ <Redirect to="/" /> } />
            <Route component={NotFound} />
        </Switch>

    )
}

export default PrivateRoutes;